import { animate, animation, keyframes, style } from '@angular/animations';

import { EASE_EMPHASIZED_ACCELERATE, EASE_EMPHASIZED_DECELERATE, TIMING_DEFAULT } from './constants';

export const lightSpeedInLeft = animation(
  animate(
    '{{ timing }}ms {{ delay }}ms {{ ease }}',
    keyframes([
      style({
        transform: 'translate3d(-100%, 0, 0) skewX(30deg)',
        opacity: 0,
        offset: 0,
      }),
      style({
        transform: 'skewX(-20deg)',
        opacity: 1,
        offset: 0.6,
      }),
      style({
        transform: 'skewX(5deg)',
        offset: 0.8,
      }),
      style({
        transform: 'translate3d(0, 0, 0)',
        offset: 1,
      }),
    ])
  ),
  {
    params: { timing: TIMING_DEFAULT, ease: EASE_EMPHASIZED_DECELERATE, delay: 0 },
  }
);

export const lightSpeedIn = animation(
  animate(
    '{{ timing }}ms {{ delay }}ms {{ ease }}',
    keyframes([
      style({
        transform: 'translate3d(100%, 0, 0) skewX(-30deg)',
        opacity: 0,
        offset: 0,
      }),
      style({
        transform: 'skewX(20deg)',
        opacity: 1,
        offset: 0.6,
      }),
      style({
        transform: 'skewX(-5deg)',
        offset: 0.8,
      }),
      style({
        transform: 'translate3d(0, 0, 0)',
        offset: 1,
      }),
    ])
  ),
  {
    params: { timing: TIMING_DEFAULT, ease: EASE_EMPHASIZED_DECELERATE, delay: 0 },
  }
);
export const lightSpeedInRight = lightSpeedIn;

export const lightSpeedOut = animation(
  animate(
    '{{ timing }}ms {{ delay }}ms {{ ease }}',
    keyframes([
      style({
        opacity: 1,
        offset: 0,
      }),
      style({
        opacity: 0,
        transform: 'translate3d(100%, 0, 0) skewX(30deg)',
        offset: 1,
      }),
    ])
  ),
  {
    params: { timing: TIMING_DEFAULT, ease: EASE_EMPHASIZED_ACCELERATE, delay: 0 },
  }
);

export const lightSpeedOutRight = lightSpeedOut;

export const lightSpeedOutLeft = animation(
  animate(
    '{{ timing }}ms {{ delay }}ms {{ ease }}',
    keyframes([
      style({
        opacity: 1,
        offset: 0,
      }),
      style({
        opacity: 0,
        transform: 'translate3d(-100%, 0, 0) skewX(-30deg)',
        offset: 1,
      }),
    ])
  ),
  {
    params: { timing: TIMING_DEFAULT, ease: EASE_EMPHASIZED_ACCELERATE, delay: 0 },
  }
);
